import type { CompanyProfile } from "~/types/company";

interface Props {
	company: CompanyProfile;
}

export function CompanyJsonLd({ company }: Props) {
	const jsonLd = {
		"@context": "https://schema.org",
		"@type": "Organization",
		name: company.name,
		taxID: company.ico,
		...(company.dic && { vatID: company.dic }),
		...(company.foundingDate && { foundingDate: company.foundingDate.split("T")[0] }),
		...(company.city && {
			address: {
				"@type": "PostalAddress",
				...(company.street && { streetAddress: company.street }),
				addressLocality: company.city,
				...(company.zip && { postalCode: company.zip }),
				...(company.region && { addressRegion: company.region }),
				addressCountry: "CZ",
			},
		}),
	};

	return (
		<script
			type="application/ld+json"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data requires dangerouslySetInnerHTML
			dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
		/>
	);
}
